<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-td w-name">
                <p class="text-primary typo--lg font-weight-medium mb-1">
                    {{ merchant.name }}
                </p>
                <p class="typo--sm mb-0">
                    ul {{ merchant.street }} {{ merchant.number }}
                    <br />
                    {{ merchant.postcode }} {{ merchant.city }}
                </p>
            </div>
            <div class="c-tw w-middle">
                <div class="c-tw w-stats">
                    <div class="c-td --last-change">
                        <span
                            class="
                                typo-label
                                d-inline-block d-sm-block d-lg-none
                                mb-sm-2
                            "
                        >Ostatnia zmiana</span>
                        <span
                            class="d-inline-block typo-number typo--lg w-100"
                        >{{
                            $moment(subscription.updated_at).format(
                                'YYYY-MM-DD, HH:mm'
                            )
                        }}</span>
                        <div
                            v-if="subscription.accepted_by_context === 'organizer'"
                            v-tooltip="'Promocja aktywowana przez centralę'"
                            class="a-badge a-badge--warning ml-3 mt-2"
                        >
                            Centrala
                        </div>
                    </div>
                    <!-- TODO : użytkownik -->
                    <!-- <div class="c-td">
                        <span
                            class="typo-label d-inline-block d-sm-block d-lg-none mb-sm-2"
                        >Użytkownik</span>
                        <span class="d-inline-block typo-number typo--lg">Jan Kowalski</span>
                    </div>-->
                    <div class="c-td mt-0 --status-promo">
                        <span
                            class="
                                typo-label
                                d-inline-block d-sm-block d-lg-none
                                mb-2
                                w-100
                            "
                        >Status promocji</span>
                        <label-state
                            class="w-100"
                            :state="labelState"
                            :tooltip="
                                labelState === 'locked_at'
                                    ? `Czas na aktywację promocji minął: ${$moment(
                                        promotion.locked_at
                                    ).format('DD-MM-YYYY, HH:mm')}`
                                    : null
                            "
                        />
                    </div>
                    <div class="c-td mt-0 --promo-limit">
                        <span
                            class="
                                typo-label
                                d-flex d-lg-none
                                align-items-center
                                mb-2
                                w-100
                            "
                        >
                            {{
                                promotion.type === PROMO_TYPES.SALES_TARGET ?
                                    'Liczba użyć / Max. próg' : 'Liczba użyć / limit'
                            }}
                            <a-icon
                                v-if="promotion.type === PROMO_TYPES.SALES_TARGET"
                                v-tooltip="'Poziom realizacji celu sprzedażowego'"
                                icon="Info"
                                width="1rem"
                                class="ml-1"
                            />
                        </span>

                        <!-- Progress bar -->
                        <progress-bar
                            text-position="down"
                            :bar-width="promoLimits.percentage"
                            type="large"
                            :progress="promoLimits.progress"
                            :steps="promoLimits.steps"
                            :limit="promoLimits.limit"
                        >
                            {{ promoLimits.amount }} /
                            {{
                                !promoLimits.limit ||
                                    +promoLimits.limit > 999998
                                    ? '&#8734;'
                                    : promoLimits.limit
                            }}
                            <a-icon
                                v-if="promotion.type !== PROMO_TYPES.SALES_TARGET && promoLimits.percentage > 89"
                                v-tooltip="
                                    'Zbliżasz się do wyczerpania limitu lub został on przekroczony!'
                                "
                                width="14"
                                height="14"
                                class="ml-1 text-warning"
                                icon="Warning"
                            />
                        </progress-bar>
                    </div>
                </div>
            </div>

            <div
                class="c-td w-actions d-flex justify-content-sm-end justify-content-start"
            >
                <div
                    class="tr__checkbox custom-control text-right p-0"
                    v-tooltip="disabledButtonText"
                >
                    <the-btn
                        v-if="isAcceptButtonVisible"
                        :disabled="
                            isLocked ||
                                subscription.suspended ||
                                subscription.state !== 'available' ||
                                group.loadingSelectedPromoIds ||
                                !isServiceActive
                        "
                        @click.native.stop.prevent="
                            selectedSubscription = !selectedSubscription
                        "
                        :text="
                            selectedSubscription
                                ? 'Dodano do aktywacji'
                                : 'Dodaj do aktywacji'
                        "
                        :class="
                            `btn-custom-gray m-promoPreviewSmallDetails__action ${
                                selectedSubscription ? 'active' : ''
                            }`
                        "
                    >
                        <a-icon
                            class="ml-2"
                            :icon="selectedSubscription ? 'Approval' : 'Plus'"
                            height="18px"
                            width="18px"
                        />
                    </the-btn>
                    <the-btn
                        v-else-if="showSubscriptionProductsPrice"
                        :disabled="
                            promotion.type === PROMO_TYPES.ADVERTISEMENT ||
                                promotion.type === PROMO_TYPES.SALES_TARGET ||
                                !isServiceActive
                        "
                        class="m-promoPreviewSmallDetails__action"
                        @click.native="openShopPrices"
                    >
                        <a-icon
                            width="16"
                            height="16"
                            class="mr-2 text-white"
                            :icon="userCanEdit
                                ? isProductsLoading
                                    ? 'Spinner'
                                    : 'Edit'
                                : 'Coin'"
                        />
                        {{ checkPricesButtonText }}
                    </the-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    props: {
        subscription: {
            type: Object,
            required: true
        },
        promotion: {
            type: Object,
            required: true
        },
        promoType: {
            type: String,
            required: true
        },
        selectGroup: {
            type: Function,
            required: true
        },
        isLocked: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isProductsLoading: false
        }
    },
    computed: {
        promoLimits() {
            // set ProgressBar steps for SALES_TARGET promotion
            if (this.promotion.type === PROMO_TYPES.SALES_TARGET) {
                const amount = +this.subscription.salesTargetUsagesAmount || 0
                const steps = this.promotion.salesTargetThresholds.map(step => {
                    return {
                        value: step.target,
                        tooltip: `Nagroda: ${this.$options.filters.currency(step.prize_amount, this.promotion.type)}`
                    }
                })
                const limit = steps.slice(-1)[0].value
                return {
                    progress: amount,
                    amount,
                    limit,
                    steps
                }
            } else {
                const storeLimits = (this.$store.getters.getPromotionsLimits || {}).usages || []
                const merchantLimits = storeLimits.find(
                    el => el.locationId === this.merchant.location_id
                )

                const amount = (merchantLimits || {}).amount || 0
                const limit = this.promotion.usage_limit_per_location || 0
                const percentage = limit ? (amount / limit) * 100 : 0

                return {
                    amount,
                    limit,
                    percentage
                }
            }
        },
        group() {
            return this.$store.getters.getPromoGroup(
                this.promotion.promo_group_id
            )
        },
        showSubscriptionProductsPrice() {
            return (
                this.subscription.state === 'accepted' || this.subscription.state === 'deleted'
            )
        },
        isAcceptButtonVisible() {
            return (
                this.subscription.state !== 'accepted' &&
                this.subscription.state !== 'deleted' &&
                this.isPromoEditPermission
            )
        },
        subscriptionCanceled() {
            return this.subscription.state === 'interrupted'
        },
        promotionShops() {
            return this.$store.getters.getPromotionShops({
                promoId: this.promotion.id,
                groupId: this.promotion.groupId
            })
        },
        merchant() {
            return this.$store.getters.getMerchantById(this.subscription.merchant_id)
        },
        selectedSubscription: {
            get() {
                return (
                    this.promotionShops &&
                    this.promotionShops.find(
                        el => el.merchant_id === this.subscription.merchant_id
                    )?.checked
                )
            },
            async set(value) {
                this.$emit('changeAllowDeselectAll')
                await this.selectGroup()
                const group = this.$store.getters.getSelectedPromoGroups[0]
                if (!group.merchantIds) {
                    await this.$store.dispatch('downloadGroupMerchants', group)
                }
                this.$store.dispatch('selectSameMerchantsAsOnPromoDetails', {
                    groupId: this.promotion.groupId,
                    promoId: this.promotion.id
                })
                this.$store.dispatch('selectShop', {
                    value,
                    promoId: this.promotion.id,
                    groupId: this.promotion.groupId,
                    shopId: this.subscription.merchant_id,
                    promotion: this.promotion,
                    fromPromoDetails: true
                })
                if (!value) {
                    this.$store.dispatch('setSelectAllSubscriptions', value)
                }
            }
        },

        isPromoEditPermission() {
            return this.$store.getters.isPromoEditPermission
        },

        isEditablePromo() {
            return this.$store.getters.isEditablePromo(this.promotion.type)
        },

        userCanEdit() {
            return this.isEditablePromo && this.isPromoEditPermission
        },

        checkPricesButtonText() {
            let text = 'Ceny'

            if (this.userCanEdit) {
                text = 'Zmień ceny'
            }

            if (
                !this.promotion.all_eans_present &&
                !this.hasProductSets
            ) {
                text += ' i kody'
            }

            if (
                this.promotion.type === 'Promo::Quota' ||
                this.promotion.type === 'Promo::BondedQuota' ||
                this.promotion.type === 'Promo::BondedPercentage'
            ) {
                text = 'Sprawdź rabat'
            }

            return text
        },

        disabledButtonText() {
            let text = ''

            if (this.subscriptionCanceled) {
                text =
                    'Ponowna aktywacja promocji w tym sklepie będzie możliwa jutro.'
            }
            if (this.isLocked) {
                if (
                    this.subscription.state === 'available' ||
                    this.subscription.state === 'interrupted'
                ) {
                    text =
                        'Ponowna aktywacja promocji nie bedzie możliwa! Minęła maksymalna data aktywacji.'
                }
            }

            return text
        },

        labelState() {
            if (this.subscription.suspended) {
                return 'subscription_suspended'
            }

            if (this.isLocked) {
                if (
                    this.subscription.state === 'available' ||
                    this.subscription.state === 'interrupted'
                ) {
                    return 'locked_at'
                }
            }

            return this.subscription.state
        },

        isServiceActive() {
            return this.subscription.company_merchant_status === 'active'
        },

        hasProductSets() {
            return this.$store.getters.hasProductSets(this.promoType)
        }
    },
    methods: {
        onFocus(event) {
            setTimeout(() => {
                event.target.select()
            }, 0)
        },
        async openShopPrices() {
            if (this.isProductsLoading) {
                return
            }

            this.isProductsLoading = true

            if (this.hasProductSets) {
                await this.fetchSetSubscriptions()
            } else {
                await this.fetchProductSubscriptions()
            }

            this.isProductsLoading = false

            this.$store.dispatch('openModal', {
                component: 'ModalShopPrices',
                args: {
                    promotion: this.promotion,
                    promoId: this.promotion.id,
                    groupId: this.promotion.groupId,
                    subscription: this.subscription,
                    group: this.group
                }
            })
        },

        async fetchProductSubscriptions() {
            try {
                const products = await this.$store.dispatch('fetchProductSubscriptions', {
                    params: {
                        subscription_id: this.subscription.id,
                        includes: 'promo_dict_product,promo_dict_product.dict_product',
                        per: 99999
                    }
                })

                this.$set(this.subscription, 'product_subscriptions', products)
                this.$set(this.subscription, 'product_set_subscriptions', [])
            } catch (error) {
                console.error('Error fetching products:', error)
            } finally {
                this.isProductsLoading = false
            }
        },

        async fetchSetSubscriptions() {
            try {
                const sets = await this.$store.dispatch('fetchSetSubscriptions', {
                    subscription_id: this.subscription.id
                })

                this.$set(this.subscription, 'product_set_subscriptions', sets)
                this.$set(this.subscription, 'product_subscriptions', [])
            } catch (error) {
                console.error('Error fetching sets:', error)
            } finally {
                this.isProductsLoading = false
            }
        }
    },

    created() {
        this.PROMO_TYPES = PROMO_TYPES
    }
}
</script>
